import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { IELTVersions } from '../models/IELTVersions'

export const fetchELTVersionsByQBR = async (uid: string): Promise<{ Data: IELTVersions[] }> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPELTVersionsByQBR/call`)
  let data: IELTVersions[] = []

  if (uid) {
    const payload = {
      'p.QBR': uid,
    }

    const {
      app: { ownerId },
    } = appGetState()
    const [accessToken] = getTokens(ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    try {
      const response = await Rest.post({ url, payload, headers })
      data = response?.Data || []
    } catch (e) {
      Logger.log(e)
    }
  }

  return { Data: data }
}
